var _path, _rect, _rect2, _path2, _rect3, _rect4, _path3, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIncognitoAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2H4V4V8V9H14V8V4V2Z",
    fill: "#ECC99E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 1,
    width: 10,
    height: 6,
    fill: "#263238"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 8,
    height: 5,
    fill: "#ECC99E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6H4V11H5V12H13V11H14V6Z",
    fill: "#ECC99E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 6,
    height: 4,
    fill: "#ECC99E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 10,
    height: 4,
    fill: "#ECC99E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15H4V16H3V18H15V16H14V15Z",
    fill: "#555757"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6,
    width: 12,
    height: 3,
    fill: "#263238"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 2,
    height: 1,
    fill: "#ECC99E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 12,
    height: 1,
    fill: "#B89879"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 16,
    height: 1,
    fill: "#263238"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 12,
    height: 1,
    fill: "#555757"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 4,
    height: 4,
    fill: "#ECC99E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    width: 4,
    height: 1,
    fill: "#CBAA88"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7,
    width: 2,
    height: 1,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 7,
    width: 2,
    height: 1,
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncognitoAvatar);
export default __webpack_public_path__ + "static/media/incognito-avatar.20e9d8ab45eaeb3193b5c7e4f6fd1155.svg";
export { ForwardRef as ReactComponent };